import { useSelector } from "react-redux";
import { getTranslations } from "../reducers/translations";
import { getStaticText } from "../reducers/staticTexts";

const useTranslation = ( staticText: string ) : string => {
    const translations = useSelector( getTranslations );
    const staticTexts = useSelector( getStaticText );
    if( translations && staticText && staticTexts && staticTexts[staticText] ) {
        return translations[staticTexts[staticText].content] || '';
    }
    return '';
}

export default useTranslation;
